import { Random2w0u2xak2xaqi as Random } from './Random.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var INV_2_26;
var INV_2_53;
function defaultPlatformRandom() {
  _init_properties_PlatformRandom_kt__6kjv62();
  // Inline function 'kotlin.js.unsafeCast' call
  var tmp$ret$0 = Math.random() * Math.pow(2, 32) | 0;
  return Random(tmp$ret$0);
}
var properties_initialized_PlatformRandom_kt_uibhw8;
function _init_properties_PlatformRandom_kt__6kjv62() {
  if (!properties_initialized_PlatformRandom_kt_uibhw8) {
    properties_initialized_PlatformRandom_kt_uibhw8 = true;
    // Inline function 'kotlin.math.pow' call
    INV_2_26 = Math.pow(2.0, -26);
    // Inline function 'kotlin.math.pow' call
    INV_2_53 = Math.pow(2.0, -53);
  }
}
//region block: exports
export {
  defaultPlatformRandom as defaultPlatformRandom1jhqtnj1rulyk,
};
//endregion

//# sourceMappingURL=PlatformRandom.mjs.map
